import { IProductDataTransformed } from '@queries/products/useProductsList/types';

export interface IProductRowProps extends IProductDataTransformed {
  className?: string;
  index: number;
}

export interface ITableCell {
  cell: JSX.Element;
}

export interface IFormattedNumberConfig {
  minimumFractionDigits: number;
  maximumFractionDigits: number;
  style: 'percent';
}

export const formattedPercentConfig: IFormattedNumberConfig = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  style: 'percent',
};
